import axios from 'axios'

export const state = {
  href: process.env.NODE_ENV === 'production' ? '' : '',
  apiBase:
    process.env.NODE_ENV === 'production'
      ? '/jaf_navi_backend'
      : 'https://yutai-test.jafnavi.jp/jaf_navi_backend',
  terminal: /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent),
  basepath: process.env.NODE_ENV === 'production' ? '/' : '/',
  mapboxAccessToken: '',
  mapboxStyle: '',
  // couponHref: process.env.NODE_ENV === 'production' ? 'https://otokunavi-smartcoco.jp/jf_app/' : 'https://test.jaf.smartcoco.jp/',

}

export const getters = {
  href: (state) => {
    return state.href
  },
  terminal: (state) => {
    return state.terminal
  },
  apiBase: (state) => {
    return state.apiBase
  },
  // couponHref: (state) => {
  //   return state.couponHref
  // },
}

export const mutations = {
  SET_MAPBOXACCESSTOKEN(state, newValue) {
    state.mapboxAccessToken = newValue
  },
  SET_MAPBOXSTYLE(state, newValue) {
    state.mapboxStyle = newValue
  },
}

export const actions = {
  fetchMapboxToken({ commit, state, rootState }) {
    const api = axios.create({
      baseURL: '',
    })
    api
      .get(state.basepath + 'config.json')
      .then((res) => {
        console.log(res)
        commit('SET_MAPBOXACCESSTOKEN', res.data.mapboxAccessToken)
        commit('SET_MAPBOXSTYLE', res.data.mapboxStyle)
      })
      .catch((err) => {
        console.log(err)
      })
  },
}
